var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ActivityLabelConditionTypeEnum, ActivityLabelTargetEnum } from '@workalizer/shared';
import { UNCATEGORIZED_LABEL_NAME } from '@workalizer/shared/config';
export var mockLabels = [
    {
        id: 1,
        name: 'Project Work',
        rules: [
            {
                target: ActivityLabelTargetEnum.DOCUMENT_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'project'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.MEETING_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'project'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'project'
                    }
                ]
            }
        ]
    },
    {
        id: 2,
        name: 'Client Communication',
        rules: [
            {
                target: ActivityLabelTargetEnum.MEETING_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'client'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'customer'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.DOCUMENT_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'client'
                    }
                ]
            }
        ]
    },
    {
        id: 3,
        name: 'Team Collaboration',
        rules: [
            {
                target: ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'team'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.MEETING_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'collaboration'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.DOCUMENT_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'team'
                    }
                ]
            }
        ]
    },
    {
        id: 4,
        name: 'Administrative Tasks',
        rules: [
            {
                target: ActivityLabelTargetEnum.MEETING_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'admin'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.DOCUMENT_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'administrative'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'admin'
                    }
                ]
            }
        ]
    },
    {
        id: 5,
        name: 'Training & Development',
        rules: [
            {
                target: ActivityLabelTargetEnum.MEETING_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'training'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.DOCUMENT_TITLES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'training'
                    }
                ]
            },
            {
                target: ActivityLabelTargetEnum.EVENT_NAMES,
                conditions: [
                    {
                        type: ActivityLabelConditionTypeEnum.CONTAINS,
                        keyword: 'training'
                    }
                ]
            }
        ]
    }
];
export var DEMO_ACTIVITY_LABEL_IDS = {
    PROJECT_WORK: 1,
    CLIENT_COMMUNICATION: 2,
    TEAM_COLLABORATION: 3,
    ADMINISTRATIVE_TASKS: 4,
    TRAINING_AND_DEVELOPMENT: 5
};
export function getDemoActivityLabelIds() {
    return mockLabels.map(function (label) { return label.id; });
}
/** All demo activity labels used across widgets (single source of truth). */
export var DEMO_COMMUNICATION_LABEL_IDS = getDemoActivityLabelIds();
export var DEMO_INITIATIVE_LABEL_IDS = DEMO_COMMUNICATION_LABEL_IDS;
export var DEMO_TIME_MANAGEMENT_LABEL_IDS = [
    DEMO_ACTIVITY_LABEL_IDS.PROJECT_WORK,
    DEMO_ACTIVITY_LABEL_IDS.CLIENT_COMMUNICATION,
    null
];
export function getDemoActivityLabelIdByName(labelName) {
    var _a;
    var label = mockLabels.find(function (entry) { return entry.name === labelName; });
    return (_a = label === null || label === void 0 ? void 0 : label.id) !== null && _a !== void 0 ? _a : null;
}
export function getDemoActivityLabelById(labelId) {
    return mockLabels.find(function (label) { return label.id === labelId; });
}
export function getDemoActivityLabelName(labelId) {
    var _a, _b;
    if (labelId === null) {
        return UNCATEGORIZED_LABEL_NAME;
    }
    return (_b = (_a = getDemoActivityLabelById(labelId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Label ".concat(labelId);
}
export function getDemoActivityLabelNames() {
    return mockLabels.map(function (label) { return label.name; });
}
export function getDemoActivityLabelNamesWithUncategorized() {
    return __spreadArray(__spreadArray([], getDemoActivityLabelNames(), true), [UNCATEGORIZED_LABEL_NAME], false);
}
